// extracted by mini-css-extract-plugin
export default {"subscriptions":"user-subscriptions_subscriptions__YEjgR","noSubscription":"user-subscriptions_noSubscription__eBx58"};